import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Space, Table, Tag } from "antd";
import { Box, TextField } from "@mui/material";

const PredefinedTemplate = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editTemplatesId, setEditTemplatesId] = useState(null);

  const [templates, setTemplates] = useState({
    templatename: "",
    predefinedtemplate: "",
  });

  const fetchTemplatesData = async () => {
    try {
      const response = await axios.get("/api/predefinedtemplate/getall");
      setData(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTemplatesData();
  }, []);

  const handleChangeTemplates = (e) => {
    const { name, value } = e.target;
    setTemplates({
      ...templates,
      [name]: value,
    });
  };

  const handleAddTemplates = (e) => {
    e.preventDefault();

    // Convert input into array: split by comma or newline
    const itemsArray = templates.predefinedtemplate
      .split(/\n+/)
      .map((item) => item.trim())
      .filter(Boolean); // remove empty strings

    const templatesData = {
      templatename: templates.templatename,
      predefinedtemplate: itemsArray, // send array to backend
    };

    console.log(templatesData);

    if (editTemplatesId) {
      axios
        .put(`/api/predefinedtemplate/update/${editTemplatesId}`, templatesData)
        .then((res) => {
          setTemplates({ predefinedtemplate: "" });
          Swal.fire({
            title: "Templates Updated successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchTemplatesData();
          });
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            "Error creating Templates. Please try again.",
            "error"
          );
        });
    } else {
      axios
        .post("/api/predefinedtemplate/create", templatesData)
        .then((res) => {
          setTemplates({ predefinedtemplate: "" });
          Swal.fire({
            title: "Templates Added successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchTemplatesData();
          });
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            "Error creating Templates. Please try again.",
            "error"
          );
        });
    }
  };

  const handleDeleteTemplates = async (_id) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      Swal.fire({
        title: "Deleting...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .delete(`/api/predefinedtemplate/delete/${_id}`)
        .then((res) => {
          fetchTemplatesData();
          Swal.fire("Deleted!", "Template deleted successfully!", "success");
        })
        .catch((error) => {
          Swal.fire("Error", "Something went wrong!", "error");
        });
    }
  };

  const handleEditTemplates = (_id) => {
    const selectedTemplates = data.find((templateid) => templateid._id === _id);

    if (selectedTemplates) {
      setEditTemplatesId(_id);

      setTemplates({
        templatename: selectedTemplates.templatename,
        predefinedtemplate: selectedTemplates.predefinedtemplate.join("\n"), // display nicely in textarea
      });
    }
    setIsModalOpen(true);
  };

  const handleAddTemplatesButton = () => {
    setEditTemplatesId(null);
    setTemplates({ predefinedtemplate: "" });
  };

  const [searchQuery, setSearchQuery] = useState("");

  const searchContacts = () => {
    return data.filter((contact) => {
      return (
        contact.predefinedtemplate &&
        contact.predefinedtemplate
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    });
  };

  const getDataSource = () => {
    if (searchQuery) {
      return searchContacts();
    } else {
      return data;
    }
  };

  const getRandomColor = () => {
    const colors = [
      "magenta",
      "red",
      "volcano",
      "orange",
      "gold",
      "lime",
      "green",
      "cyan",
      "blue",
      "geekblue",
      "purple",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const columns = [
    {
      title: "ID",
      key: "id",
      render: (text, record, index) => index + 1,
      fixed: "left",
      width: 50,
    },
    {
      title: "Template Name",
      dataIndex: "templatename",
      key: "templatename",
      ellipsis: true,
      align: "center",
    },
    {
      title: "Predefined Template",
      dataIndex: "predefinedtemplate",
      key: "predefinedtemplate",
      ellipsis: true,
      align: "center",
      render: (tags) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {tags?.map((tag, index) => (
            <Tag key={index} color={getRandomColor()}>
              <span
                style={{
                  fontWeight: "600",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                {tag}
              </span>
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "ACTION",
      key: "action",
      width: 150,
      render: (text, record) => (
        <Space size="middle">
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            className="edit-btn"
            onClick={() => handleEditTemplates(record._id)}
          >
            <i className="ri-pencil-fill"></i>
          </button>
          <button
            onClick={() => handleDeleteTemplates(record._id)}
            className="delete-btn"
          >
            <i className="ri-delete-bin-fill"></i>
          </button>
        </Space>
      ),
    },
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchQuery(e.target.value);
  };

  return (
    <div className="page-content w-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">Predefined Templates</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12">
            <div id="contactList" className="card">
              <div className="card-header py-3">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex flex-wrap flex-grow-1 gap-2">
                    <button
                      type="button"
                      className="btn btn-primary add-btn"
                      onClick={handleAddTemplatesButton}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i> Add
                      Template
                    </button>
                    {/* <form
                      className="d-flex"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <input
                        className="form-control me-2"
                        type="search"
                        id="search"
                        placeholder="Search"
                        aria-label="Search"
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                    </form> */}
                    <div
                      className="modal fade"
                      id="exampleModal"
                      tabIndex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden={!isModalOpen}
                      style={{ display: isModalOpen ? "block" : "none" }}
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              {editTemplatesId
                                ? "Update Templates"
                                : "Add Templates"}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <Box>
                              <TextField
                                color="primary"
                                fullWidth
                                label="Template Name"
                                name="templatename"
                                value={templates.templatename}
                                onChange={handleChangeTemplates}
                                margin="normal"
                                required
                              />

                              <TextField
                                color="primary"
                                fullWidth
                                label="Template Items"
                                name="predefinedtemplate"
                                value={templates.predefinedtemplate}
                                onChange={handleChangeTemplates}
                                margin="normal"
                                required
                                multiline
                                rows={6}
                              />
                            </Box>
                          </div>
                          <div className="modal-footer">
                            <button
                              onClick={handleAddTemplates}
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="modal"
                            >
                              {editTemplatesId ? "Update" : "Save"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0"></div>
                </div>
                <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                  <div className="flex-shrink-0">
                    <div className="hstack text-nowrap gap-2 align-item-center"></div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <Table
                  dataSource={getDataSource()}
                  columns={columns}
                  rowKey="_id"
                  scroll={{ x: true }}
                  style={{ overflowX: data.length > 5 ? "scroll" : "hidden" }}
                  pagination={{
                    pageSize: 5,
                  }}
                  components={{
                    header: {
                      cell: ({ style, ...restProps }) => (
                        <th
                          {...restProps}
                          style={{
                            ...style,
                            backgroundColor: "#c6c6c6",
                            color: "black",
                            textAlign: "center",
                          }}
                        />
                      ),
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PredefinedTemplate;
